import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAdminAuth } from "@/contexts/AdminAuthContext";

const RequireAdmin = ({ children }) => {
  const { isAuthenticated, checking } = useAdminAuth();
  const location = useLocation();

  if (checking) {
    return (
      <div className="min-h-screen bg-[var(--bg-alt)] flex items-center justify-center">
        <div className="text-sm text-[var(--slate)]" data-testid="admin-checking">
          Checking session…
        </div>
      </div>
    );
  }
  if (!isAuthenticated) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/admin/login?next=${next}`} replace />;
  }
  return children;
};

export default RequireAdmin;
